import { Voter } from "@activecollab/security";
import { isClient, isOwner } from "~/utils/userHelper";

export class CalendarEventVoter extends Voter {
  attributes = ["delete", "restore", "edit", "permanently-delete", "drag"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject && subject.class === "CalendarEvent";
  }

  voteOnAttribute(attribute, subject, user) {
    const calendar = this.getCalendar(subject);
    switch (attribute) {
      case "delete":
      case "edit": {
        if (isClient(user)) {
          return false;
        }
        if (isOwner(user)) {
          return true;
        }
        if (subject.created_by_id === user.id) {
          return true;
        }

        if (calendar && calendar.created_by_id === user.id) {
          return true;
        }
        return false;
      }
      case "restore": {
        const calendar = this.getCalendar(subject);
        if (!calendar || calendar.is_trashed) {
          return false;
        }
        if (user.class === "Owner") {
          return true;
        }
        if (user.id === subject.trashed_by_id) {
          return true;
        }
        return false;
      }
      case "permanently-delete": {
        if (user.class === "Owner") {
          return true;
        }
        return false;
      }
      case "drag": {
        if (isClient(user)) {
          return false;
        }
        if (calendar.class === "ExternalCalendar") {
          return false;
        }
        if (subject?.pending) {
          return false;
        }
        if (isOwner(user)) {
          return true;
        }
        if (subject.created_by_id === user.id) {
          return true;
        }

        if (calendar && calendar.created_by_id === user.id) {
          return true;
        }

        return false;
      }
    }

    throw new Error("This code should not be reached!");
  }

  getCalendar = (subject) => {
    if (subject.calendar_id && this.state.calendars) {
      return this.state.calendars[subject.calendar_id];
    }
  };
}
